/**
 * @fileoverview POST handler for the "/api/calculated_attributes/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postApiCalculatedAttributesAppGroupIdCacheKeys } from "./constants";
import type {
  PostApiCalculatedAttributesAppGroupIdProps,
  PostApiCalculatedAttributesAppGroupIdResult,
  PostApiCalculatedAttributesAppGroupIdResultErrors,
} from "./types";

export const postApiCalculatedAttributesAppGroupId = reactQueryMutationAdapter(
  postApiCalculatedAttributesAppGroupIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostApiCalculatedAttributesAppGroupIdResultErrors>()(
    (props: PostApiCalculatedAttributesAppGroupIdProps): Promise<PostApiCalculatedAttributesAppGroupIdResult> => {
      return fetch(
        `/api/calculated_attributes/${props.appGroupId}`,
        "POST",
        { calculated_attribute: props.calculated_attribute },
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  )
);
